import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const fetchAnnee = createAsyncThunk("annee/fetchAnnee", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "annee/allAnnee", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },

  });
  const annee = await response.json();
  return annee;
});

export const anneeAdded = createAsyncThunk("annee/addAnnee", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "annee/addAnnee", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body: JSON.stringify(action)

  });
  const annee = await response.json();
  return annee;
});
export const anneeUpdated = createAsyncThunk("annee/updateAnnee", async (data) => {
  const response = await fetch(Configuration.BACK_BASEURL + "annee/addAnnee", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(data),
  });

  const annee = await response.json();
  return annee;
});

export const anneeDeleted = createAsyncThunk("annee/deleteAnnee", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "annee/deleteAnnee/"+id, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });

  const annee = await response.json();
  return annee;
});
export const anneeGetById = createAsyncThunk("annee/anneeGetById", async (id1) => {
  const  id  = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "annee/getAnnee", {
    method: 'POST',
    headers: {
      'id':id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
  
  });
  const annee = await response.json();
  return annee;
});
const anneeReduce = createSlice({
  name: "annee",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {    
    // anneeUpdated: (state, action) => async (dispatch) => {
    //   try {
    //     // Dispatch an action to update loading state (optional)
    //     dispatch({ type: 'ANNEE_LOADING', payload: true });

    //     // Perform the asynchronous operation (fetch)
    //     const response = await fetch(Configuration.BACK_BASEURL + "annee/addAnnee", {
    //       method: 'POST',
    //       headers: {
    //         'Accept': 'application/json',
    //         'Content-Type': 'application/json',
    //         'x-access-token': token
    //       },
    //       body: JSON.stringify(action.payload), // Assuming action.payload contains the data you want to send
    //     });

    //     // Check if the request was successful
    //     if (response.ok) {
    //       // Dispatch an action to update state with the received data
    //       const data = await response.json();
    //       dispatch({ type: 'ANNEE_UPDATED', payload: data });
    //     } else {
    //       // Handle errors here (dispatch an error action, update loading state, etc.)
    //       console.error('Error updating annee:', response.statusText);
    //     }

    //   } catch (error) {
    //     console.error('Error updating annee:', error);
    //   } finally {
    //     // Dispatch an action to update loading state (optional)
    //     dispatch({ type: 'ANNEE_LOADING', payload: false });
    //   }
    // },
    // anneeDeleted(state, action) {
    //   const { id } = action.payload;
    //   fetch(Configuration.BACK_BASEURL + "annee/deleteAnnee/"+id, {
    //     method: 'DELETE',
    //     headers: {
    //       'Accept': 'application/json',
    //       'Content-Type': 'application/json'
    //     },
    //   });
    // },

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnnee.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchAnnee.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, ...action.payload];
      })
      .addCase(fetchAnnee.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(anneeGetById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(anneeGetById.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, action.payload];
      })
      .addCase(anneeGetById.rejected, (state, action) => {
        state.loading = false;
      });
  },
  
});

export const {   } = anneeReduce.actions;

export default anneeReduce.reducer;
